import { Text, VFlow } from 'bold-ui'
import React from 'react'

import { NewsHeadingSection } from './NewsHeadingSection'

export function NewsInternalVEstabilizacao() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 4.0.16' subtitle=' | 04/12/2020'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>Atualização da competência SIGTAP para Setembro de 2020.</Text>
          <Text component='li'>
            Ajustes na tela de Finalizar atendimento odontológico onde o campo de conduta não estava sendo apresentado
            corretamente.
          </Text>
          <Text component='li'>
            Correção de erro que impedia a impressão dos Encaminhamentos em algumas instalações que não possuíam a fonte
            "SansSerif".
          </Text>
          <Text component='li'>
            Melhorias de desempenho no módulo de Transmissão de dados no campo "Existem fichas para processar".
          </Text>
        </VFlow>
      </NewsHeadingSection>

      <NewsHeadingSection title='Versão 4.0.15' subtitle=' | 12/11/2020'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de erro em que o atalho para os agendamentos do cidadão na agenda não estava funcionando
            corretamente para cadastros unificados.
          </Text>
          <Text component='li'>
            Correção de erro que impedia a atualização em algumas situações em instalações com banco de dados Oracle.
          </Text>
        </VFlow>
      </NewsHeadingSection>

      <NewsHeadingSection title='Versão 4.0.14' subtitle=' | 05/11/2020'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>Correção de erros que impediam a inicialização do sistema em instalações Oracle.</Text>
          <Text component='li'>
            Correção de inconsistências no horário decorrentes do cancelamento do horário de verão.
          </Text>
        </VFlow>
      </NewsHeadingSection>

      <NewsHeadingSection title='Versão 4.0.13' subtitle=' | 22/10/2020'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de cenário em que algumas funcionalidades não eram exibidas no centro da tela.
          </Text>
          <Text component='li'>
            Criação de uma opção de filtro na listagem de Cadastros Individuais para visualização de fichas inativadas
            incorretamente através da unificação de cadastros, esse filtro será exibido somente se existirem cadastros
            nessa situação.
          </Text>
        </VFlow>
      </NewsHeadingSection>
    </VFlow>
  )
}
